<template>
  <b-overlay
    :show="loading"
    rounded
    opacity="0.7"
    spinner-small
    spinner-variant="primary"
  >
    <div class="order-service-delivery-quotation">
      <!-- Форма редактирования котировки -->
      <div v-if="shouldShowForm">
        <p>Постарайтесь заполнить форму максимально подробно. Это сократит время на дальнейшее ведение поставки.</p>
        <b-form>
          <b-form-row class="mb-2">
              <b-col cols="5" class="mb-2">
                  <!-- 0. Направление перевозки -->
                  <b-form-group label="Направление перевозки">
                      <b-form-radio-group 
                          v-model="quotation.supply_way" 
                          :options="supplyWayTypes"
                      ></b-form-radio-group>
                  </b-form-group>
              </b-col>
              <b-col cols="5" class="mb-2">
                  <!-- 0. Тип перевозки -->
                  <!-- <template v-if="!isWasSplitted && [359, 539, 540].includes(order_reference_status_id)"> -->
                  <b-form-group label="Типы перевозок на расчет">
                      <b-form-checkbox-group
                          v-model="quotation.selected_transport_types_id"
                          :options="transportTypeOptions"
                          stacked
                      >
                      </b-form-checkbox-group>
                      <small v-if="!quotation.selected_transport_types_id || !quotation.selected_transport_types_id.length" class="text-danger">Это поле обязательно для заполнения.</small>
                  </b-form-group>
                  <!-- </template> -->
                  <!-- <template v-else>
                      <b-form-group label="Тип перевозки на расчет">
                          <template v-if="quotation.transport_types_id">
                              {{ referencePropertyById(quotation.transport_types_id) }}
                          </template>
                          <template v-else>
                              <small class="text-danger">Тип перевозки не выбран. Для выбора типа перевозки, переведите заказ в статус "Запросы / Лиды" или "Контакт с клиентом".</small>
                          </template>
                      </b-form-group>
                  </template> -->
              </b-col>
          </b-form-row>

          <b-row>
              <b-col :cols="quotation.loading_places.length > 0 ? '12':'4'">
                  <!-- 1. Место загрузки -->
                  <b-form-group 
                      label="Место загрузки" 
                      description="Укажите точное место, откуда будет осуществляться загрузка груза." 
                      class="position-relative"
                      :invalid-feedback="invalidFeedbackLoadingPlace"
                      :state="quotation.loading_places.length > 0"
                  >
                      <b-button @click="addLoadingPlace" class="btn btn-sm btn-outline-secondary small-select-fly">Добавить<i class="fas fa-plus ml-2"></i></b-button>

                      <b-form-row
                          v-for="(loadingPlace, index) in quotation.loading_places" 
                          :key="'loadingPlace-' + index"
                          class="mb-2"
                      >
                          <b-col cols="3">
                              <tsoft-select-of-properties
                                  :key="`set_loading_place_country_id_${index}`"
                                  placeholder="Выберите страну"
                                  :reference_id="20"
                                  :index="index"
                                  :needNullElement="false"
                                  :needMultipleSelect="false"
                                  :defaultSelectName="``"
                                  :selected="loadingPlace.country_id"
                                  @set="setLoadingPlaceCountry"
                              ></tsoft-select-of-properties>
                              <small v-if="!loadingPlace.country_id" class="text-danger">Это поле обязательно для заполнения.</small>
                          </b-col>
                          <b-col cols="3">
                              <b-form-input v-model="loadingPlace.city" size="sm" class="input-near-select" placeholder="Введите город"></b-form-input>
                              <!-- <small v-if="!loadingPlace.city" class="text-danger">Это поле обязательно для заполнения.</small> -->
                          </b-col>
                          <b-col cols="5">
                              <b-form-input v-model="loadingPlace.address" size="sm" class="input-near-select" placeholder="Введите адрес"></b-form-input>
                              <small v-if="!loadingPlace.address" class="text-danger">Это поле обязательно для заполнения.</small>
                          </b-col>
                          <b-col cols="auto d-flex" style="padding-top: 4px;">
                              <b-button @click="removeLoadingPlace(index)" class="btn btn-sm btn-outline-secondary"><i class="far fa-trash-alt"></i></b-button>
                          </b-col>
                      </b-form-row>
                  </b-form-group>
              </b-col>

              <b-col :cols="quotation.unloading_places.length > 0 ? '12':'4'">
                  <!-- 4. Место разгрузки -->
                  <b-form-group 
                      label="Место разгрузки"
                      description="Укажите город разгрузки, а в случае, если груз сборный – обязательно точный адрес склада грузополучателя." 
                      class="position-relative"
                      :invalid-feedback="invalidFeedbackUnLoadingPlace"
                      :state="quotation.unloading_places.length > 0"
                  >
                      <b-button @click="addUnloadingPlace" class="btn btn-sm btn-outline-secondary small-select-fly">Добавить<i class="fas fa-plus ml-2"></i></b-button>

                      <b-form-row
                          v-for="(unloadingPlace, index) in quotation.unloading_places"
                          :key="'unloadingPlace-' + index"
                          class="mb-2"
                      >
                          <b-col cols="3">
                              <tsoft-select-of-properties
                                  :key="`set_unloading_place_country_id_${index}`"
                                  placeholder="Выберите страну"
                                  :reference_id="20"
                                  :index="index"
                                  :needNullElement="false"
                                  :needMultipleSelect="false"
                                  :defaultSelectName="``"
                                  :selected="unloadingPlace.country_id"
                                  @set="setUnloadingPlaceCountry"
                              ></tsoft-select-of-properties>
                              <small v-if="!unloadingPlace.country_id" class="text-danger">Это поле обязательно для заполнения.</small>
                          </b-col>
                          <b-col cols="3">
                              <b-form-input v-model="unloadingPlace.city" size="sm" class="input-near-select" placeholder="Введите город"></b-form-input>
                              <!-- <small v-if="!unloadingPlace.city" class="text-danger">Это поле обязательно для заполнения.</small> -->
                          </b-col>
                          <b-col cols="5">
                              <b-form-input v-model="unloadingPlace.address" size="sm" class="input-near-select" placeholder="Введите адрес"></b-form-input>
                              <small v-if="!unloadingPlace.address" class="text-danger">Это поле обязательно для заполнения.</small>
                          </b-col>
                          <b-col cols="auto d-flex" style="padding-top: 4px;">
                              <b-button @click="removeUnloadingPlace(index)" class="btn btn-sm btn-outline-secondary"><i class="far fa-trash-alt"></i></b-button>
                          </b-col>
                      </b-form-row>
                  </b-form-group>
              </b-col>

              <b-col :cols="quotation.clearance_places.length > 0 ? '12':'4'">
                  <!-- 3. Место растаможки -->
                  <b-form-group 
                      label="Место растаможки"
                      description="Укажите место растаможки, если растаможка будет осуществляться силами Клиента." 
                      class="position-relative"
                      :invalid-feedback="invalidFeedbackClearencePlace"
                      :state="quotation.clearance_places.length > 0"
                  >
                      <b-button @click="addClearancePlace" class="btn btn-sm btn-outline-secondary small-select-fly">Добавить<i class="fas fa-plus ml-2"></i></b-button>

                      <b-form-row
                          v-for="(clearancePlace, index) in quotation.clearance_places"
                          :key="'clearancePlace-' + index"
                          class="mb-2"        
                      >
                          <b-col cols="3">
                              <tsoft-select-of-properties
                                  :key="`set_clearance_place_country_id_${index}`"
                                  placeholder="Выберите страну"
                                  :reference_id="20"
                                  :index="index"
                                  :needNullElement="false"
                                  :needMultipleSelect="false"
                                  :defaultSelectName="``"
                                  :selected="clearancePlace.country_id"
                                  @set="setClearancePlaceCountry"
                              ></tsoft-select-of-properties>
                              <small v-if="!clearancePlace.country_id" class="text-danger">Это поле обязательно для заполнения.</small>
                          </b-col>
                          <b-col cols="3">
                              <b-form-input v-model="clearancePlace.city" size="sm" class="input-near-select" placeholder="Введите город"></b-form-input>
                              <!-- <small v-if="!clearancePlace.city" class="text-danger">Это поле обязательно для заполнения.</small> -->
                          </b-col>
                          <b-col cols="5">
                              <b-form-input v-model="clearancePlace.address" size="sm" class="input-near-select" placeholder="Введите адрес"></b-form-input>
                              <small v-if="!clearancePlace.address" class="text-danger">Это поле обязательно для заполнения.</small>
                          </b-col>
                          <b-col cols="auto d-flex" style="padding-top: 4px;">
                              <b-button @click="removeClearancePlace(index)" class="btn btn-sm btn-outline-secondary"><i class="far fa-trash-alt"></i></b-button>
                          </b-col>
                      </b-form-row>
                  </b-form-group>
              </b-col>
          </b-row>

          <!-- 6. Описание груза -->
          <b-form-group>
              <b-form-row>
                  <b-col cols="8" class="mb-2">
                      <b-form-group label="Детализация груза" class="corrected-multiselect__tags">
                          <div class="mb-3">
                              <b-form-input v-model="quotation.cargo_name" required size="sm" placeholder="Наименование груза"></b-form-input>
                              <small v-if="!quotation.cargo_name" class="text-danger">Это поле обязательно для заполнения.</small>
                          </div>

                          <b-form-textarea 
                              v-model="quotation.cargo_details" 
                              size="sm" 
                              placeholder="Опишите груз, требования, условия поставки, если это необходимо..."
                          ></b-form-textarea>
                      </b-form-group>
                  </b-col>
                  <b-col cols="4" class="mb-2">
                      <b-form-group label="Дата готовности груза" description="">
                          <div cols="12" class="mb-2" v-if="!quotation.isIndicative">
                              <b-form-input v-model="quotation.next_transport_date" size="sm" type="date"></b-form-input>
                              <!-- <small v-if="!quotation.next_transport_date" class="text-danger">Это поле обязательно для заполнения.</small> -->
                          </div>
                          <div class="d-flex align-items-center mb-2">
                              <b-form-checkbox 
                                  v-model="quotation.isIndicative"
                              >Индикатив</b-form-checkbox>
                          </div>
                      </b-form-group>
                  </b-col>
              </b-form-row>
          </b-form-group>

          <!-- 9. Размеры и объем груза -->
          <b-form-group label="Размеры и объем груза">
            <b-form-row class="mb-2">
              <b-col cols="12" class="mb-2">
                  <b-form-row>
                      <b-col cols="4" class="mb-2">
                        <b-form-radio-group v-model="quotation.cargoType" :options="cargoTypes"></b-form-radio-group>
                      </b-col>
                      <b-col cols="4" class="mb-2">
                        <b-form-radio-group v-model="quotation.cargoSize" :options="cargoSizeTypes"></b-form-radio-group>
                      </b-col>
                  </b-form-row>
          
                  <b-form-row>
                      <b-col class="mb-2">
                          <b-form-input 
                              v-model="quotation.gross_weight" 
                              type="number" 
                              min="0.01" 
                              step="0.01"
                              required 
                              size="sm" 
                              placeholder="Укажите вес груза, кг"
                          ></b-form-input>
                          <small v-if="!quotation.gross_weight" class="text-danger">Это поле обязательно для заполнения.</small> 
                          <small else>Вес груза, кг</small>   
                      </b-col>
                      <b-col class="mb-2">
                          <b-form-input 
                              v-model="quotation.dimensions.volume" 
                              type="number" 
                              min="0" 
                              step="0.01" 
                              required 
                              size="sm" 
                              placeholder="Объем (м3)"
                          ></b-form-input>
                          <small v-if="!quotation.dimensions.volume" class="text-danger">Это поле обязательно для заполнения.</small>    
                          <small else>Объем (м3)</small>
                      </b-col>
                      <b-col class="mb-2">
                          <b-form-input 
                              v-model="quotation.number_of_places" 
                              type="number" min="1" 
                              step="1" 
                              :required="(quotation.cargoType === 'Сборный' || quotation.cargoSize === 'Не габаритный') && !quotation.number_of_places"
                              size="sm" 
                              placeholder="Кол-во мест"
                          ></b-form-input>
                          <small v-if="(quotation.cargoType === 'Сборный' || quotation.cargoSize === 'Не габаритный') && !quotation.number_of_places" class="text-danger">Это поле обязательно для заполнения.</small>    
                          <small else>Кол-во мест</small>
                      </b-col>
                  </b-form-row>
                  
                  <!-- Блок размеров грузовых мест -->
                  <div v-if="quotation.number_of_places" class="mt-3">
                      <b-form-group label="Укажите размеры грузовых мест для получения максимально корректной ставки (в сантиметрах)">
                          <div 
                              v-for="(place, index) in (quotation.cargo_places || [])" 
                              :key="'cargo-place-' + index"
                              class="mb-2"
                          >
                              <b-form-row>
                                  <b-col cols="2">
                                      <b-form-input 
                                          v-model="place.length" 
                                          type="number" 
                                          min="0.01" 
                                          step="0.01"
                                          size="sm" 
                                          placeholder="Длина (см)"
                                      ></b-form-input>
                                      <small>Длина (см)</small>
                                  </b-col>
                                  <b-col cols="2">
                                      <b-form-input 
                                          v-model="place.width" 
                                          type="number" 
                                          min="0.01" 
                                          step="0.01"
                                          size="sm" 
                                          placeholder="Ширина (см)"
                                      ></b-form-input>
                                      <small>Ширина (см)</small>
                                  </b-col>
                                  <b-col cols="2">
                                      <b-form-input 
                                          v-model="place.height" 
                                          type="number" 
                                          min="0.01" 
                                          step="0.01"
                                          size="sm" 
                                          placeholder="Высота (см)"
                                      ></b-form-input>
                                      <small>Высота (см)</small>
                                  </b-col>
                                  <b-col cols="2">
                                      <b-form-input 
                                          v-model="place.quantity" 
                                          type="number" 
                                          min="1" 
                                          step="1"
                                          size="sm" 
                                          placeholder="Кол-во мест"
                                      ></b-form-input>
                                      <small>Кол-во мест</small>
                                  </b-col>
                                  <b-col cols="3">
                                      <b-form-input 
                                          v-model="place.packaging_type" 
                                          size="sm" 
                                          placeholder="Тип упаковки"
                                      ></b-form-input>
                                      <small>Тип упаковки</small>
                                  </b-col>
                                  <b-col cols="1" class="d-flex align-items-start" style="padding-top: 3px;">
                                      <b-button 
                                          v-if="index < (quotation.cargo_places || []).length - 1"
                                          @click="removeCargoPlace(index)" 
                                          variant="danger" 
                                          size="sm"
                                      >
                                          <i class="fas fa-trash"></i>
                                      </b-button>
                                      <b-button 
                                          v-else
                                          @click="addCargoPlace" 
                                          variant="success" 
                                          size="sm"
                                      >
                                          <i class="fas fa-plus"></i>
                                      </b-button>
                                  </b-col>
                              </b-form-row>
                          </div>
                          
                          <!-- Показываем общую сумму мест -->
                          <div v-if="(quotation.cargo_places || []).length > 0" class="mt-2">
                              <small class="text-muted">
                                  Общее количество мест: {{ totalCargoPlacesQuantity }} 
                                  <!-- <span v-if="quotation.number_of_places && totalCargoPlacesQuantity !== quotation.number_of_places" class="text-warning">
                                      (не совпадает с указанным количеством мест: {{ quotation.number_of_places }})
                                  </span> -->
                              </small>
                          </div>
                      </b-form-group>
                  </div>
                  
                  <hr class="my-2">
                  <b-form-row>
                      <b-col cols="6">
                          <b-form-checkbox 
                              v-model="quotation.isStackingOfCargo"
                          >Штабелировка груза</b-form-checkbox>
                      </b-col>
                  </b-form-row>
              </b-col>
              <!-- <b-col cols="4">
                  <b-form-group label="Габариты позиций">
                      <b-form-textarea 
                          v-model="quotation.dimensions.details" 
                          :required="quotation.cargoType === 'Сборный' || quotation.cargoSize === 'Не габаритный'"
                          size="sm" 
                          rows="5"
                          placeholder="Опишите габариты каждой позиции, например так: 2 паллета, 5 коробок 30*30*70, 10 коробок 40*50, 2 штанги 600*10*10 и так далее..."
                      ></b-form-textarea>
                      <small v-if="!quotation.dimensions.details && (quotation.cargoType === 'Сборный' || quotation.cargoSize === 'Не габаритный')" class="text-danger">Это поле обязательно для заполнения.</small>
                  </b-form-group>
              </b-col> -->
            </b-form-row>
          </b-form-group>

        </b-form>
      </div>

      <!-- Текстовое отображение котировки -->
      <div v-else>
            <OrderServiceDeliveryQuotationInfo 
              :quotation="{ data: quotation }"
            />
      </div>

      <!-- Форма для заполнения ставок логистов -->
      <template v-if="(order_reference_status_id == 541 && isAgent) || (order_reference_status_id == 541 && !isLogisticsManager)">
        <div class="mt-4">
          <div class="alert alert-info border-left-info">
            <div class="d-flex align-items-center">
              <div class="mr-3">
                <i class="fas fa-clock fa-2x text-info"></i>
              </div>
              <div>
                <p>
                  <strong>Над котированием уже работают наши логисты!</strong>
                </p>
                <p class="mb-0 text-muted">
                  Как только все типы транспорта будут прокотированы, Вы сможете увидеть наши ставки и продолжить работать с клиентом.
                </p>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <OrderServiceQuotationAnswerForms
          v-if="quotationId && quotation.selected_transport_types_id && quotation.selected_transport_types_id.length > 0"
          :order-id="order_id"
          :order-service-id="order_service_id"
          :selected-transport-types="quotation.selected_transport_types_id"
          :order-service-quotation-id="quotationId"
          :order-reference-status-id="order_reference_status_id"
          ref="quotationAnswerForms"
          @orderUpdated="handleOrderUpdated"
        />
      </template>

      <!-- Кнопки управления - отображаются в обоих режимах -->
      <hr>
      <b-row>
          <b-col cols="12" class="d-flex justify-content-between">
              <div>
                <b-button 
                  v-if="!isAgent"
                  type="link" 
                  variant="outline-secondary" 
                  :disabled="loading || saving"
                  @click.prevent="showAsLetterSidebar=true"
                >Шаблон письма для поставщика</b-button>
              </div>
              <div class="text-right" v-if="order_reference_order_type_id == 1">
                <div class="mb-2">
                  <b-button 
                    v-if="[359, 539, 540].includes(order_reference_status_id)"
                    type="button" 
                    variant="success"
                    :disabled="loading || saving"
                    class="ml-2"
                    @click.prevent="handleSubmit(false)"
                  >Сохранить</b-button>

                  <b-button 
                    v-if="[359, 539, 540].includes(order_reference_status_id)"
                    type="button" 
                    variant="primary"
                    class="ml-2"
                    :disabled="loading || saving || !isFormValid"
                    @click.prevent="handleSubmit(true)"
                  >
                    Сохранить и отправить на котировку
                    <i class="fas fa-arrow-right ml-2"></i>
                  </b-button>

                  <b-button 
                    v-if="order_reference_status_id == 542"
                    type="link" 
                    variant="primary"
                    :disabled="loading || saving"
                    @click.prevent="changeToQuotationSentStatus(543)"
                  >
                    Перевести в статус «КП Направлено»
                    <i class="fas fa-arrow-right ml-2"></i>
                  </b-button>

                  <div
                    v-if="order_reference_status_id == 543"
                  >
                    <b-button 
                      v-if="isAgent || isAdmin"
                      type="link" 
                      variant="secondary"
                      class="ml-2"
                      :disabled="loading || saving"
                      @click.prevent="requestDiscount()"
                    >Запросить скидку</b-button>

                    <b-button 
                      variant="primary"
                      class="ml-2"
                      :disabled="loading || saving"
                      @click.prevent="askAboutTransportSelection"
                    >
                      Перевести в поставку
                      <i class="fas fa-arrow-right ml-2"></i>
                    </b-button>                  
                    <!-- <b-button 
                      variant="danger"
                      class="btn28-uppercase ml-2"
                      :disabled="loading || saving"
                      @click.prevent="changeToQuotationSentStatus(362)"
                    >Закрыть заявку</b-button> -->
                  </div>
                </div>

                <div
                  v-if="[359, 539, 540].includes(order_reference_status_id)"
                >
                <div class="text-right lh12px">
                        <small>
                          <em>После отправки Заявки на котировку,<br />
                            форма запроса на котировку будет закрыта для редактирования.<br />
                            Будьте внимательны при заполнении!
                          </em>
                        </small>
                    </div>
                </div>
                <div 
                    v-if="order_reference_status_id == 541"
                >
                    <div class="text-right lh12px">
                        <small>
                          <em>Заявка отправлена на «Получение котировки».<br />
                            Как только все типы транспорта будут прокотированы, <br />
                            Заявка автоматически будет переведена в статус «Котировка получена» и вы получите уведомление.<br />
                            После этого вы увидите ставки логистов, которые будут доступны для просмотра и редактирования.
                          </em>
                        </small>
                    </div>
                    
                    <!-- Кнопка перевода в статус "Котировка получена" -->
                    <div v-if="shouldShowManualStatusChangeButton" class="mt-3">
                        <div class="alert alert-warning">
                            <div class="d-flex align-items-center">
                                <div class="mr-3">
                                    <i class="fas fa-exclamation-triangle fa-2x text-warning"></i>
                                </div>
                                <div>
                                    <p class="mb-1">
                                        <strong>Внимание!</strong> Заказ уже ранее находился в статусе "Получение котировки".
                                    </p>
                                    <p class="mb-2 text-muted">
                                        Возможно, требуется ручная смена статуса для продолжения работы.
                                    </p>
                                    <b-button 
                                        variant="primary"
                                        size="sm"
                                        @click="changeToQuotationReceivedStatus"
                                        :disabled="loading || saving"
                                    >
                                        <i class="fas fa-arrow-right mr-1"></i>
                                        Перевести в статус «Котировка получена»
                                    </b-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>          
                <div 
                    v-if="order_reference_status_id == 542"
                >
                    <div class="text-right lh12px">
                        <small>
                          <em>Заявка в статусе «Котировка получена».<br />
                            Ожидается проставление ставок для клиента и перевод в статус «КП Направлено».
                          </em>
                        </small>
                    </div>
                </div>          
                <div 
                    v-if="order_reference_status_id == 543"
                >
                    <div class="text-right lh12px">
                        <small>
                          <em>Заявка в статусе «КП Направлено».<br />
                            Как только будет понятно работаем мы по этой Заявке или нет, 
                            <br />выполните перевод Заявки в Поставку или закройте заявку.
                          </em>
                        </small>
                    </div>
                </div>          
              </div>
          </b-col>
      </b-row>
    </div>

    <b-sidebar         
      v-model="showAsLetterSidebar"
      id="show-as-letter-sidebar-right" 
      title="Как будет выглядеть запрос в письме" 
      right 
      shadow
      backdrop
      width="70%"
    >
      <div class="px-3 py-2">
        <DeliveryQuotationLetter 
          v-if="showAsLetterSidebar"
          :quotation="quotation"
        />
      </div>
    </b-sidebar>      

  </b-overlay>
</template>

<script>
import { mapGetters } from 'vuex';

import { 
  API_POST_ORDER_SERVICES_QUOTATIONS_SAVE, 
  API_POST_ORDER_SERVICES_QUOTATIONS_FIND,
  API_ORDERS_ACTION_HISTORY,
  API_ORDER_VALIDATE_STATUS_541,
  API_ORDER_VALIDATE_STATUS_542,
} from '@/constants';

import { tablePrepareData, orderMethods } from '@/mixins';
import { quotationValidationMixin } from '@/mixins/quotationValidationMixin';

import DeliveryQuotationTransportTypes from '@/components/orders/orderServiceQuotation/DeliveryQuotationTransportTypes';
import OrderServiceDeliveryQuotationInfo from '@/components/orders/orderServiceQuotation/OrderServiceDeliveryQuotationInfo';
import DeliveryQuotationLetter from '@/components/orders/orderServiceQuotation/DeliveryQuotationLetter';
import OrderServiceQuotationAnswerForms from '@/components/orders/orderServiceQuotation/OrderServiceQuotationAnswerForms';
import { template } from 'lodash';

export default {
  props: {
    order_id: { type: Number|String, required: true },
    order_service_id: { type: Number|String, required: true },
    order_reference_status_id: { type: Number|String, required: true },
    order_reference_order_type_id: { type: Number|String, required: true }
  },
  components: {
    DeliveryQuotationTransportTypes,
    OrderServiceDeliveryQuotationInfo,
    DeliveryQuotationLetter,
    OrderServiceQuotationAnswerForms
  },
  mixins: [tablePrepareData, orderMethods, quotationValidationMixin],
  data() {
    return {
      loading: false,
      saving: false,
      isWasSplitted: false,
      deliveryQuotationTTSidebar: false,
      showAsLetterSidebar: false,
      adrTypes: ['Не знаю', 'ADR', 'Не ADR'],
      supplyWayTypes: ['Международная', 'Внутрироссийская'],
      stackableTypes: ['Не знаю', 'Штабелируемый', 'Не штабелируемый'],
      cargoTypes: ['Сборный', 'Генеральный'],
      cargoSizeTypes: ['Габаритный', 'Не габаритный'],
      paymentPeriodTypes: ['Календарные дни', 'Рабочие дни'],
      paymentFromCopiesTypes: ['от копий', 'от оригиналов'],
      quotationId: null,
      orderStatusHistory: [],
      showManualStatusChangeButton: false,
      quotation: {
        supply_way: 'Международная',
        selected_transport_types_id: [],
        transport_types_id: null,
        loading_places: [],
        customs_places: [],
        clearance_places: [],
        unloading_places: [],
        reverse_direction: 'Не знаю',
        reverse_details: '',
        cargo_name: '',
        cargo_code: '',
        cargo_details: '',
        adr: 'Не знаю',
        set_delivery_conditions_ids: [],
        stackable: 'Не знаю',
        packaging_type: '',
        gross_weight: null,
        dimensions: { length: null, width: null, height: null, volume: null, details: '' },
        number_of_places: null,    // Количество мест
        cargo_places: [],          // Массив грузовых мест с размерами
        cargoType: 'Сборный',
        cargoSize: 'Габаритный',
        cargo_invoice_value: null,
        cargo_invoice_currency_id: null,
        cargo_declared_value: null,
        cargo_declared_currency_id: null,
        transport_types_and_kinds: [], // [{ transport_item_id, transport_category_id, transport_item_name, transport_category_name, transport_category_type, quantity }]
        supply_frequency_id: null,
        supply_count: 1,
        next_transport_date: '',
        isIndicative: false,
        isStackingOfCargo: false,
        transit_directions_ids: [],
        special_partner_requirements_ids: [],
        payment_terms: 'Не знаю',
        prepayment_percentage: null,
        payment_from_copies: 'Постоплата с копий',
        payment_period: null,
        payment_period_type: 'Календарные дни',
        indicative_rate_from_client_value: null,
        indicative_rate_from_client_currency_id: null,
        additional_terms: ''
      },
      savedTransport: {}
    };
  },
  computed: {
    ...mapGetters(['REFERENCE_PROPERTIES']),
    ...mapGetters("auth", ["currentUser"]),
    
    isAdmin() {
      return this.currentUser.role.includes('administrator');
    },

    isAgent() {
      return this.currentUser.role.includes('agent');
    },

    isLogisticsManager() {
      return this.currentUser.role.includes('logistics-manager') || 
             this.currentUser.role.includes('logistics-head-manager') || 
             this.currentUser.role.includes('logistics-multim-manager') || 
             this.currentUser.role.includes('logistics-multim-head-manager');
    },

    shouldShowForm() {
      // Форма показывается когда: нет выбранного типа транспорта И статус 539 или 540 или 359
      // const hasNoTransportTypes = !this.quotation.transport_types_id;
      const isNotQuotationStatus = this.order_reference_status_id == 359 || this.order_reference_status_id == 539 || this.order_reference_status_id == 540;
      // return hasNoTransportTypes || isNotQuotationStatus;
      return isNotQuotationStatus;
    },

    isFormValid() {
        const requiredFields = [
            this.quotation.cargo_name,
            this.quotation.gross_weight,
            this.quotation.dimensions.volume,
        ];

        const areAllLoadingPlacesFilled = this.quotation.loading_places.every(place => place.country_id && place.address);
        const areAllClearancePlacesFilled = this.quotation.clearance_places.every(place => place.country_id && place.address);
        const areAllUnloadingPlacesFilled = this.quotation.unloading_places.every(place => place.country_id && place.address);

        // Размеры грузовых мест теперь необязательны
        let areAllCargoPlacesFilled = true;

        return requiredFields.every(field => !!field) 
                && areAllLoadingPlacesFilled 
                && areAllClearancePlacesFilled 
                && areAllUnloadingPlacesFilled
                && areAllCargoPlacesFilled
                && this.quotation.selected_transport_types_id.length > 0;
    },
    transportTypeOptions() {
      // Получаем все reference properties
      const all = this.$store.getters.GROUPED_REFERENCE_PROPERTIES[86];

      // Фильтруем по reference_id = 86 и исключаем 999, 1000, 1001
      return Object.values(all)
        .filter(item => item.reference_id === 86 && ![999, 1000, 1001].includes(item.id))
        .map(item => ({ text: item.name, value: item.id }));
    },
    invalidFeedbackLoadingPlace() {
        if (this.quotation.loading_places.length === 0) {
            return 'Необходимо добавить адрес.';
        }

        return '';
    },
    invalidFeedbackUnLoadingPlace() {
        if (this.quotation.unloading_places.length === 0) {
            return 'Необходимо добавить адрес.';
        }

        return '';
    },
    invalidFeedbackClearencePlace() {
        if (this.quotation.clearance_places.length === 0) {
            return 'Необходимо добавить адрес.';
        }

        return '';
    },
    totalCargoPlacesQuantity() {
        if (!this.quotation.cargo_places) {
            return 0;
        }
        return this.quotation.cargo_places.reduce((total, place) => {
            return total + (parseInt(place.quantity) || 0);
        }, 0);
    },
    
    // Проверяем количество переходов в статус 541
    status541Count() {
        return this.orderStatusHistory.filter(item => 
            item.history_type === 'order_status' && 
            item.reference_status_id === 541
        ).length;
    },
    
    // Проверяем, нужно ли показать кнопку ручной смены статуса
    shouldShowManualStatusChangeButton() {
        return this.order_reference_status_id === 541 && 
               this.status541Count >= 2 && 
               !this.isAgent;
    }
  },
  watch: {
    "quotation.transport_types_id": {
      handler(newVal, oldVal) {
        if (!this.loading) {
          this.savedTransport[oldVal] = JSON.parse(JSON.stringify(this.quotation.transport_types_and_kinds));
          this.quotation.transport_types_and_kinds = [];

          if (this.savedTransport[newVal]) {
            this.quotation.transport_types_and_kinds = JSON.parse(JSON.stringify(this.savedTransport[newVal]));
          }
        }
      },
    }, 
    isFormValid: {
      handler() {
        this.$emit("isRequestFormValid", this.isFormValid);
      },
      immediate: true
    },
    "quotation.number_of_places": {
      handler(newVal) {
        // Инициализируем cargo_places если его нет
        if (!this.quotation.cargo_places) {
          this.$set(this.quotation, 'cargo_places', []);
        }
        
        // Если указано количество мест и нет грузовых мест, создаем первое место
        if (newVal && newVal > 0 && this.quotation.cargo_places.length === 0) {
          this.addCargoPlace();
        }
        // Если количество мест стало 0 или null, очищаем грузовые места
        if (!newVal || newVal <= 0) {
          this.quotation.cargo_places = [];
        }
      }
    }
  },  
  mounted() {
    this.setDefaultValues();
    this.loadDeliveryQuotation();
    this.loadOrderStatusHistory();
  },
  methods: {
    handleOrderUpdated(data) {
      // После успешного обновления на бэке подождем локальной синхронизации данных
      // и только потом эмитим событие наверх
      this.$nextTick(() => {
        this.$emit('orderUpdated', data);
      });
    },
    setDefaultValues() {
        // this.addLoadingPlace();
        // this.addClearancePlace();
        // this.addUnloadingPlace();
    },
    loadDeliveryQuotation() {
      this.loading = true;

      const params = {
        order_id: this.order_id,
        order_service_id: this.order_service_id
      };

      api.call('post', API_POST_ORDER_SERVICES_QUOTATIONS_FIND, params).then(({data}) => {
        if (data.success === true) {
          this.quotation = data.quotation.data;
          this.quotationId = data.quotation.id;
          this.isWasSplitted = data.is_was_splitted;
          this.$emit("setValuesFromQuotation", data.quotation);
        }
      }).catch((error) => {
        console.error('Ошибка при загрузке данных:', error);
        this.$bvToast.toast('Произошла ошибка при загрузке данных', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true,
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    
    // Загружаем историю статусов заказа
    async loadOrderStatusHistory() {
      try {
        const { data } = await axios.get(`${API_ORDERS_ACTION_HISTORY}/${this.order_id}`);
        this.orderStatusHistory = data || [];
      } catch (error) {
        console.error('Ошибка при загрузке истории статусов:', error);
      }
    },
    async handleSubmit(isSaveWithStatusChange = false) {
      this.saving = true;

      try {
        // Сначала сохраняем форму без смены статуса
        const savePayload = {
          order_id: this.order_id,
          order_service_id: this.order_service_id,
          change_status_of_order: 0, // Всегда сохраняем без смены статуса
          data: this.quotation,
        };

        const saveResponse = await api.call('post', API_POST_ORDER_SERVICES_QUOTATIONS_SAVE, savePayload);
        
        // Показываем сообщение об успешном сохранении
        this.$bvToast.toast('Данные успешно сохранены', {
          title: 'Успешное сохранение котировки!',
          variant: 'success',
          solid: true,
        });

        // Если нужно сменить статус, выполняем валидацию и смену статуса
        if (isSaveWithStatusChange) {
          // Выполняем валидацию перед сменой статуса
          const validationResponse = await api.call('post', API_ORDER_VALIDATE_STATUS_541, {
            order_id: this.order_id
          });

          console.log(validationResponse.data);
          // Проверяем успешность валидации
          if (!validationResponse.data.success) {
            // Показываем ошибки валидации
            console.log("inside", validationResponse.data);
            this.handleValidationErrors(validationResponse.data);
            return;
          }

          // Если валидация прошла успешно, меняем статус
          const statusPayload = {
            order_id: this.order_id,
            order_service_id: this.order_service_id,
            change_status_of_order: 1,
            data: this.quotation,
          };

          const statusResponse = await api.call('post', API_POST_ORDER_SERVICES_QUOTATIONS_SAVE, statusPayload);
          
          this.loading = true;

          // Эмитим событие для обновления данных у родителя
          setTimeout(() => {
            this.$emit('orderUpdated', {
              orderId: this.order_id,
              message: 'Статус поставки обновлен на «Получение котировки»'
            });
            this.loading = false;
          }, 3000);

          this.$bvToast.toast('Данные успешно сохранены. Статус поставки обновлен на «Получение котировки».', {
            title: 'Успешное сохранение котировки!',
            variant: 'success',
            solid: true,
          });
        } else {
          this.$emit("saved");
        }

      } catch (error) {
        console.error('Ошибка при сохранении данных:', error);
        this.loading = false;

        this.$bvToast.toast('Произошла ошибка при сохранении данных', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true,
        });
      } finally {
        this.saving = false;
      }
    },
    addLoadingPlace() {
      this.quotation.loading_places.push({ country_id: null, city: '', address: '' });
    },
    removeLoadingPlace(index) {
      this.quotation.loading_places.splice(index, 1);
    },
    addCustomsPlace() {
      this.quotation.customs_places.push({ country_id: null, city: '', address: '' });
    },
    removeCustomsPlace(index) {
      this.quotation.customs_places.splice(index, 1);
    },
    addClearancePlace() {
      this.quotation.clearance_places.push({ country_id: null, city: '', address: '' });
    },
    removeClearancePlace(index) {
      this.quotation.clearance_places.splice(index, 1);
    },
    addUnloadingPlace() {
      this.quotation.unloading_places.push({ country_id: null, city: '', address: '' });
    },
    removeUnloadingPlace(index) {
      this.quotation.unloading_places.splice(index, 1);
    },
    setTransportTypes(value) {
      this.quotation.selected_transport_types_id = value;
    },
    setTransitDirections(value) {
      this.quotation.transit_directions_ids = value;
    },
    setSupplyFrequency(value) {
      this.quotation.supply_frequency_id = value;
    },
    setSpecialPartnerRequirements(value) {
      this.quotation.special_partner_requirements_ids = value;
    },
    setDeliveryConditions(value) {
      this.quotation.set_delivery_conditions_ids = value;
    },
    setLoadingPlaceCountry(value, reference_id, index) {
      this.quotation.loading_places[index].country_id = value;
    },
    setCustomsPlaceCountry(value, reference_id, index) {
      this.quotation.customs_places[index].country_id = value;
    },
    setClearancePlaceCountry(value, reference_id, index) {
      this.quotation.clearance_places[index].country_id = value;
    },
    setUnloadingPlaceCountry(value, reference_id, index) {
      this.quotation.unloading_places[index].country_id = value;
    },
    setCargoInvoiceCurrency(value) {
      this.quotation.cargo_invoice_currency_id = value;
    },
    setCargoDeclaredCurrency(value) {
      this.quotation.cargo_declared_currency_id = value;
    },
    setDeliveryQuotationTransportTypes(transport_types_and_kinds) {
      this.quotation.transport_types_and_kinds = transport_types_and_kinds;
      this.closeDeliveryQuotationTTSidebar();
    },
    setIndicativeRateFromClientCurrency(value) {
      this.quotation.indicative_rate_from_client_currency_id = value;
    },
    closeDeliveryQuotationTTSidebar() {
      this.deliveryQuotationTTSidebar = false;
    },
    addCargoPlace() {
      if (!this.quotation.cargo_places) {
        this.$set(this.quotation, 'cargo_places', []);
      }
      this.quotation.cargo_places.push({
        length: null,
        width: null,
        height: null,
        quantity: 1,
        packaging_type: ''
      });
    },
    removeCargoPlace(index) {
      if (this.quotation.cargo_places) {
        this.quotation.cargo_places.splice(index, 1);
      }
    },
    referencePropertyById(id) {
      return this.REFERENCE_PROPERTIES[id] ? this.REFERENCE_PROPERTIES[id].text : 'Неизвестно';
    },
    async changeToQuotationSentStatus(status) {
      // Если переводим в статус 542 (Котировка получена), выполняем валидацию
      if (status === 542) {
        try {
          // Выполняем валидацию перед сменой статуса
          const validationResponse = await api.call('post', API_ORDER_VALIDATE_STATUS_542, {
            order_id: this.order_id
          });

          // Проверяем успешность валидации
          if (!validationResponse.data.success) {
            // Показываем ошибки валидации
            this.handleValidationErrors(validationResponse.data);
            return;
          }
        } catch (error) {
          console.error('Ошибка при валидации статуса:', error);
          this.$bvToast.toast('Произошла ошибка при проверке валидации', {
            title: 'Ошибка валидации',
            variant: 'danger',
            solid: true,
            autoHideDelay: 5000
          });
          return;
        }
      }

      // Для статуса 543 (КП Направлено) валидация не требуется
      // Эмитируем событие для изменения статуса заказа
      this.$emit('changeOrderToQuotationSent', this.order_id, status);

      // Эмитим событие для обновления данных в дочерних компонентах
      this.$emit("orderUpdated", {
        orderId: this.order_id,
        message: 'Статус заказа обновлен'
      });
    },

    /**
     * Запрос скидки - специальный метод для обработки запроса скидки
     */
    async requestDiscount() {
      try {
        // Предложить пользователю ввести комментарий к запросу скидки
        const { value: discountMsg, isConfirmed } = await this.$swal({
          title: 'Запросить скидку',
          input: 'textarea',
          inputPlaceholder: 'Опишите причину и детали скидки (необязательно)',
          inputAttributes: {
            'aria-label': 'Сообщение для запроса скидки'
          },
          showCancelButton: true,
          cancelButtonText: 'Отмена',
          confirmButtonText: 'Отправить',
        });

        if (!isConfirmed) {
          return;
        }

        // Напрямую вызываем updateAnyOrder с флагом запроса скидки и сообщением
        const updateFields = {
          reference_status_id: 542,
          is_discount_request: true,
          order_service_id: this.order_service_id,
          discount_request_message: discountMsg || ''
        };

        await this.updateAnyOrder(this.order_id, updateFields);
        
        // Эмитим событие для обновления данных в дочерних компонентах
        this.$emit("orderUpdated", {
          orderId: this.order_id,
          message: 'Запрос скидки отправлен'
        });
      } catch (error) {
        console.error('Ошибка при отправке запроса скидки:', error);
        this.$bvToast.toast('Ошибка при отправке запроса скидки', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true
        });
      }
    },
    askAboutTransportSelection() {
      // Проверяем наличие выбранной ставки
      if (!this.hasSelectedQuotation()) {
        this.$bvToast.toast('Необходимо выбрать утвержденную ставку перед переводом в поставку', {
          title: 'Выберите ставку',
          variant: 'warning',
          solid: true
        });
        return;
      }

      // Если ставка выбрана, переводим заказ в поставку
      this.$emit('makeOrderSupply', this.order_id);

      // Эмитим событие для обновления данных в дочерних компонентах
      setTimeout(() => {
        this.$emit("orderUpdated", {
            orderId: this.order_id,
            message: 'Статус заказа обновлен!'
        });
      }, 2000);
    },

    hasSelectedQuotation() {
      // Получаем доступ к компоненту с котировками через $refs
      const quotationAnswerForms = this.$refs.quotationAnswerForms;
      
      if (!quotationAnswerForms) {
        return false;
      }

      // Проверяем, есть ли ответы и есть ли среди них выбранные (status === 'selected')
      const answers = quotationAnswerForms.answers || [];
      return answers.some(answer => answer.status === 'selected');
    },
    
    // Метод для перевода в статус "Котировка получена"
    async changeToQuotationReceivedStatus() {
      try {
        // Выполняем валидацию перед сменой статуса
        const validationResponse = await api.call('post', API_ORDER_VALIDATE_STATUS_542, {
          order_id: this.order_id
        });

        // Проверяем успешность валидации
        if (!validationResponse.data.success) {
          // Показываем ошибки валидации
          this.handleValidationErrors(validationResponse.data);
          return;
        }

        // Обновляем статус заказа на 542 (Котировка получена)
        const updateFields = {
          reference_status_id: 542,
          order_service_id: this.order_service_id
        };

        await this.updateAnyOrder(this.order_id, updateFields);
        
        // Эмитим событие для обновления данных в дочерних компонентах
        this.$emit("orderUpdated", {
          orderId: this.order_id,
          message: 'Статус заказа изменен на "Котировка получена"'
        });

        this.$bvToast.toast('Статус заказа успешно изменен на "Котировка получена"', {
          title: 'Успех',
          variant: 'success',
          solid: true
        });

      } catch (error) {
        console.error('Ошибка при смене статуса:', error);
        this.$bvToast.toast('Ошибка при смене статуса заказа', {
          title: 'Ошибка',
          variant: 'danger',
          solid: true
        });
      }
    }
  }
};
</script>

<style scoped>
.order-service-delivery-quotation {
  min-height: 500px;
}
.input-near-select {
  padding: 0.40rem 0.5rem;
}
.btn.small-select-fly {
  position: absolute;
  left: 144px;
  top: -32px;
  font-size: 11px;
  padding: 0px 8px;
  height: 25px;
  background: #FFF;
  color: #aaaaaa;
  text-transform: none;
}
.btn.small-select-fly:hover {
  background: #aaaaaa;
  color: #FFF;
}
.btn.select-transport-button {
  left: 293px;
}

#show-as-letter-sidebar-right .b-sidebar-body {
  background: #FFF;
}
small.text-danger {
  display: block;
  line-height: 13px;
  margin-top: 3px;
}
</style>
